import { getCourses, getDeleteHistory } from '@/api/delete-course'
export default {
    state: {
        courses: [],
        history: [],


    },

    mutations: {

        SET_DELETEABLE_COURSES: (state, data) => {
            state.courses = data
        },
        SET_DELETE_COURSES_HISTORY: (state, data) => {
            state.history = data
        },


    },

    actions: {
        getDeleteableCourses({ commit }) {

            return new Promise((resolve, reject) => {
                getCourses().then(response => {

                    if (!response.data) {
                        reject('error')
                    }
                    const data = response.data;
                    commit('SET_DELETEABLE_COURSES', data)
                    resolve(response)

                }).catch(error => {
                    reject(error)
                })
            })
        },
        getDeleteHistory({ commit }) {
            commit('SET_TABLE_TEXT', true)
            return new Promise((resolve, reject) => {
                getDeleteHistory().then(response => {

                    if (!response.data) {
                        reject('error')
                    }
                    const data = response.data;
                    commit('SET_DELETE_COURSES_HISTORY', data)
                    commit('SET_TABLE_TEXT', false)

                    resolve(response)

                }).catch(error => {
                    reject(error)
                })
            })
        }

    }
}